import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useGoTo() {
  const navigate = useNavigate();
  const location = useLocation();
  return (href) => {
    if (href.startsWith("#")) {
      if (location.pathname === "/") {
        document.getElementById(href.slice(1))?.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/", { state: { scrollTo: href.slice(1) } });
      }
    } else {
      navigate(href);
    }
  };
}

export function ScrollManager() {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (state?.scrollTo) {
      const t = setTimeout(() => {
        document.getElementById(state.scrollTo)?.scrollIntoView({ behavior: "smooth" });
      }, 250);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0 });
  }, [pathname, state]);
  return null;
}
